import api from 'services/api/microfwk';

export function fetchInfoSerie(params) {
  return api.get('services/content/serie', { params });
}

export function fetchRecommendedContent(params) {
  return api.get('services/content/recommendations', { params });
}

export function fetchContentRecommendations(params = {}) {
  return api.get('/services/content/recommendations', {
    params,
  });
}

export function fetchSerieSeenLast(params = {}) {
  return api.get('services/user/seenlast', { params });
}
